import Insurance from './Insurance';

export default Insurance;
